module.exports = __webpack_public_path__ + "img/bi.c369d84d.png";